export const getStatistics = async ({ forUsers, forReservation }) => {
  const API_URL = process.env.REACT_APP_API_URL + "statistics/";
  const token = localStorage.getItem("token");

  try {
    console.log("Fetching statistics with params:", { forUsers, forReservation });
    console.log("API URL:", API_URL);
    console.log("Token exists:", !!token);

    const response = await fetch(
      `${API_URL}?forUsers=${forUsers}&forReservation=${forReservation}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    console.log("Response status:", response.status);
    console.log("Response ok:", response.ok);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API Error Response:", errorText);
      throw new Error(`Failed to fetch statistics: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log("Statistics data received:", data);

    // Return data with proper structure
    return {
      reservationsNumber: data.reservationsNumber || 0,
      usersNumber: data.usersNumber || 0,
      popularPackages: Array.isArray(data.popularPackages) ? data.popularPackages : [],
      profit: Array.isArray(data.profit) ? data.profit : [],
      dailyBookings: Array.isArray(data.dailyBookings) ? data.dailyBookings : [],
    };
  } catch (error) {
    console.error("Statistics API Error:", error);
    
    // Check if it's a network error
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error("Netzwerkfehler: Kann keine Verbindung zum Server herstellen");
    }
    
    // Check if it's an authentication error
    if (error.message.includes('401')) {
      throw new Error("Authentifizierungsfehler: Bitte melden Sie sich erneut an");
    }
    
    // Check if it's a server error
    if (error.message.includes('500')) {
      throw new Error("Serverfehler: Bitte versuchen Sie es später erneut");
    }
    
    throw error;
  }
};
